const cell_font_size = '17';
// const title_font_size = '20';
const employee_cell_font_size = '12';

/**
 * Rounds a number to two decimal places using `Math.round(x * 100) / 100`.
 * @param {number} x Numeric value to round.
 * @return {number} Value rounded to two decimal places.
 */
export const roundup = (x) => {
  return (Math.round(x*100) / 100);
}

/**
 * Parses a value as a float, or returns 0 when the value is empty, nullish, or not numeric.
 * @param {*} x Input (number, numeric string, or invalid/empty).
 * @return {number} Parsed float, or `0` for zero/invalid inputs.
 */
export const changeFloat = (x) => {
  if((x!== null) && !isNaN(x) && x!=='' && x!== undefined){
    if (x === '0' || x === 0) {return 0}
    return parseFloat(x);
  }
  return 0;
}

/**
 * Formats a numeric value to two decimals with thousands separators for Excel-style cells.
 * Negative values include a second array element `'negative'` for downstream styling.
 * @param {*} x Numeric value or numeric string; non-numeric or nullish yields `[null]`.
 * @return {Array} `[0]` for zero; `[formattedString]` for positive; `[formattedString, 'negative']` for negative; `[null]` if not a number.
 */
export const numberWithCommas = (x) => {
  if (x === null || x === undefined) return [null];
  if (x === '0' || x === 0) return [0];

  // Accept comma-formatted numeric strings (e.g. "1,234.56") by stripping commas.
  if (typeof x === 'string') {
    const stripped = x.replace(/,/g, '');
    if (!isNaN(stripped)) x = stripped;
  }

  if (!isNaN(x)) {
    var y = roundup(x).toFixed(2);
    if (y < 0) {
      return [y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 'negative'];
    }
    return [y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")];
  }

  return [null];
}

/**
 * Returns a display string with thousands separators and two fixed decimal places.
 * @param {*} x Numeric value or numeric string.
 * @return {string} Formatted string (e.g. `"1,234.50"`), or `'0.00'` for zero; non-numeric inputs are returned unchanged.
 */
export const numberWithCommas_display = (x) => {
  if (x === null || x === undefined) return x;
  if (x === '0' || x === 0) return '0.00';

  // Accept comma-formatted numeric strings (e.g. "1,234.56").
  if (typeof x === 'string') {
    const stripped = x.replace(/,/g, '');
    if (!isNaN(stripped)) x = stripped;
  }

  if (!isNaN(x)) {
    var y = roundup(x).toFixed(2);
    return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return x;

}

/**
 * Removes comma thousands separators from a value that JavaScript treats as numeric (`!isNaN(x)`).
 * Values like `"1,234"` are returned unchanged because they fail the numeric check.
 * @param {*} x Number, numeric string without commas, or other (e.g. null).
 * @return {string|*} String without commas, `'0'` for zero variants, or the original `x` when not numeric or nullish.
 */
export const removeCommas = (x) => {
  // console.log('Remove commas', x);
  if (x === null || x === undefined) return x;

  if (x === 0.00 || x === '0.00' || x === 0 || x === '0') {
    return '0';
  }

  // If x is a comma-formatted numeric string, strip commas.
  if (typeof x === 'string' && x.includes(',')) {
    const stripped = x.replace(/,/g, '');
    if (!isNaN(stripped)) return stripped;
    return x;
  }

  if (!isNaN(x)) return x.toString();

  return x;

}

/**
 * Normalizes string numeric input: zero becomes `0`; strings with two or more fractional digits are fixed to two decimals.
 * Intended for string `x` (uses `indexOf` / `substring`); non-numeric or nullish inputs return `0`.
 * @param {*} x String or number (zero only safe for non-string path).
 * @return {number|string} `0` for invalid/zero; otherwise the string or `toFixed(2)` string when decimals need trimming.
 */
export const validInput = (x) => {
  if (x === null || x === undefined) return 0;
  if (isNaN(x)) return 0;
  if (x === '0' || x === 0) return 0;

  // The original implementation assumes string input (uses indexOf on '.').
  // For safety, normalize numbers into strings.
  if (typeof x === 'number') x = x.toString();

  // Only string inputs can reach indexOf/substring safely.
  x = String(x);

  var dec = x.indexOf('.');
  if (dec !== -1) {
    // reading the decimal places count
    var decPlaces = x.substring(dec + 1, x.length).length;
    if (decPlaces >= 2) {
      x = parseFloat(x);
      x = x.toFixed(2);
    }
  }

  return x;
}

/**
 * Builds an xlsx-style cell descriptor for employee export: alignment, font size, optional wrap, and value formatting.
 * @param {*} value Cell value (number formatted with commas when `string` is false, or raw string when true).
 * @param {boolean} string When true, value is written as text; leading `-` applies red font.
 * @param {boolean} wrap When true, sets vertical center and wrap text on alignment.
 * @return {Object} Cell object with `value` and `style` (alignment, font, optional color).
 */
export const borderedCell_employee = (value, string, wrap) => {
  var cell = {};
  cell.style = {
                  alignment:{
                    horizontal: 'right',
                    vertical: 'bottom'
                  },
                  font:{ sz:employee_cell_font_size}
                }
  if (string){
    if (String(value).startsWith('-') ){
      cell.style.font.color = {rgb: "FF0000"};
    }
    cell.value = value;
    // cell.style.alignment.horizontal = 'right';
  }
  else{
    if (value !== null && value!=='null' && value !== 0 && value !== '0' && value !== undefined){
      var v = numberWithCommas(value);
      // console.log(value)
      cell.value = v[0];

      if (v.length > 1){
        cell.style.font.color = {rgb: "FF0000"};
      }

    }
    else{
      // cell.value = '';
      cell.value = (0).toFixed(2);
    }
  }

  if(wrap){
    // cell.style.fill = {pattern: "solid", fgColor: {rgb: "D4D4D4"}};
    cell.style.alignment.vertical = "center";
    cell.style.alignment.wrapText = true;
  }
  return cell;
}

/**
 * Builds an xlsx-style cell descriptor for payroll export: borders, alignment, font size, percent vs text handling, optional total row styling.
 * @param {*} value Cell value; numbers get comma formatting unless zero (then `"0.00"`). Strings ending in `%` are right-aligned; other strings are left-aligned.
 * @param {boolean} string When true, treats `value` as text (percent vs non-percent branches).
 * @param {boolean} total When true, applies gray fill and bold font for total rows.
 * @return {Object} Cell object with `value` and `style` (border, alignment, font, optional color/fill/bold).
 */
export const borderedCell_payroll = (value, string, total) => {
  var cell = {};
  cell.style = {
                  border: {
                    top: { style: "medium", color: "black" },
                    bottom: { style: "medium", color: "black" },
                    left: { style: "medium", color: "black" },
                    right: { style: "medium", color: "black" }
                  },
                  alignment:{
                    horizontal: 'right',
                    vertical: 'bottom'
                  },
                  font:{ sz:cell_font_size}
                }
  if (string){
    if (String(value).endsWith('%') ){
      cell.value = value;
      cell.style.alignment.horizontal = 'right';

      if (value.startsWith('-')){
        cell.style.font.color = {rgb: "FF0000"};
      }

    }
    else{
      cell.value = value;
      cell.style.alignment.horizontal = 'left';
    }

  }
  else{
    if (value !== null && value!=='null' && value !== 0 && value !== '0'){
      var v = numberWithCommas(value);

      cell.value = v[0];

      if (v.length > 1){
        cell.style.font.color = {rgb: "FF0000"};
      }
    }
    else{
      cell.value = (0).toFixed(2);
      // cell.value = '';
    }
  }



  if(total){
    cell.style.fill = {pattern: "solid", fgColor: {rgb: "D4D4D4"}};
    cell.style.font.bold = true;
  }
  return cell;
}
